// Update contents object below

const contents = {
  header: 'Intel Corporation',
  video:
    'https://player.vimeo.com/video/894569345?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  videoTitle: 'Intel Video1',
  title: 'Intel and Numenta are Changing the Game with AI',
  copy: 'AI is evolving in exciting new ways, including emulating the human mind. Bay Area software developer Numenta is partnering with Intel to create groundbreaking AI-based software. This film explores how game studio Gallium—founded by Will Wright—is using the Numenta-Intel solution to create a powerful game that uses memories and human emotion.',
  url: 'https://sponsorcontent.cnn.com/interactive/intel/it-starts-with-intel/',
  button: 'More Intel Stories'
};

export default contents;
